import React from 'react'
import { twMerge } from 'tailwind-merge'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string | JSX.Element
  error?: string
  inputClassName?: string
  labelClassName?: string
}

function FormInput({
  label,
  value,
  onChange,
  onFocus,
  maxLength,
  error,
  placeholder,
  required,
  className,
  inputClassName,
  labelClassName,
  name,
  type = 'text',
  disabled,
  spellCheck = false,
  autoComplete,
  autoCapitalize,
  ...rest
}: InputProps) {
  return (
    <label
      className={twMerge('flex flex-col gap-1 text-sm font-medium text-text-primary', className)}
    >
      {(label || required) && (
        <div className="flex gap-0.5">
          {label && <span className={labelClassName}>{label}</span>}
          {required && <span className="text-red">*</span>}
        </div>
      )}
      <input
        className={twMerge(
          'mt-1 w-full rounded-lg border border-text-secondary/30 px-4 py-2.5 focus:outline-none',
          inputClassName,
        )}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        maxLength={maxLength}
        placeholder={placeholder}
        spellCheck={spellCheck}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        disabled={disabled}
        {...rest}
      />
      {error && <p className="mt-2 text-sm text-danger">{error}</p>}
    </label>
  )
}

export default FormInput
